function getFullName(person) {
    return [person.first_name, person.middle_name, person.last_name]
        .filter(name => name) // Removes null or empty values
        .join(" "); // Joins the names with a space
}
export default getFullName;